<wiz-vgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  <wiz-hgroup width="100%" height="100%">

  <wiz-vgroup width="250px" height="100%" class="section-container"><!-- zone champs libres & filtre -->
    <wiz-hgroup  width="100%">
      <wiz-label width="100%" [wizLabel]="'$.freedata.edit.field.all.$'" class="smallTitleLabel"></wiz-label>
      <wiz-icon  style="cursor: pointer;" class="image-purple"  [wizTooltip]="'$.common.delete.$'"  (click)="onDeleteClick()">delete </wiz-icon>
    </wiz-hgroup>
   
    <wiz-list
      #freeList
      id="freeList"
      height="100%"
      width="100%"
      [wizItemRenderer]="renderer"
      [wizDataProvider]="dataSource"
      [wizLabelField]="'fullCode'"
      [dragEnabled]="true"
    ></wiz-list>
  </wiz-vgroup>

  <wiz-vgroup #vgDetailZone width="100%" height="100%"> <!-- zone détail : poser les champs -->  

    <wiz-vgroup width="100%" height="100%"><!-- zone lignes et datas -->
      <freegridster wizDragDrop 
          [model]="model"
          [wizDropEnabled]="true" width="100%" height="100%" 
          (widgetsChanged)="onWidgetsChanged($event)" 
          [widgets]="widgets" 
          [templatingMode]="true"></freegridster>
    </wiz-vgroup>
  </wiz-vgroup>
  </wiz-hgroup>


  <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="center" class="section-container">
    <wiz-button
      #btnSave
      width="150px"
      (click)="doValid()"
      [wizLabel]="'$.common.save.modification.$'"
      [wizIcon]="'icon-arrow-right'"
      [iconPlacement]="'right'"
    ></wiz-button>
    <wiz-button
      #btnCancel
      width="150px"
      (click)="doCancel()"
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>
  </wiz-hgroup>

  <!-- fin zone détail -->
</wiz-vgroup>
